export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1100px] flex-col gap-lg px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs max-w-[680px] text-[13px] text-subtle',
	search:
		'w-full max-w-[320px] rounded-md border border-default bg-white px-xs py-3xs text-[13px] text-default placeholder:text-subtle focus:border-purple-500 focus:outline-none',
	table: 'w-full overflow-hidden rounded-lg border border-subtle bg-white text-left',
	th: 'border-b border-subtle px-md py-xs text-[11px] font-medium uppercase tracking-wider text-subtle',
	td: 'border-b border-subtle/50 px-md py-sm align-top text-[13px] text-default',
	tech: 'font-mono text-[12px] text-subtle',
};
